<template>
    <div class="flex flex-wrap items-start justify-between gap-4">
        <div class="flex items-center gap-3">
            <div
                class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-indigo-600"
            >
                <CalendarDaysIcon class="h-6 w-6 text-white" />
            </div>
            <div>
                <h1 class="text-2xl font-bold tracking-tight text-gray-900">
                    {{ t("vue.kiosk_da_app_title") }}
                </h1>
                <p class="mt-0.5 text-sm text-gray-500">
                    {{ t("vue.kiosk_da_description") }}
                </p>
            </div>
        </div>
        <div class="flex items-center gap-2">
            <span class="text-sm font-medium text-gray-500">
                {{ isToday ? t("vue.today") : t("vue.kiosk_da_selected_day") }}:
            </span>
            <input
                id="activity-date"
                v-model="localDate"
                type="date"
                class="rounded-lg border-0 px-3 py-1.5 text-sm text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600"
                @change="applyDate"
            />
            <button
                type="button"
                class="rounded-lg bg-white px-3 py-1.5 text-sm font-medium text-gray-700 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                @click="goToToday"
            >
                {{ t("vue.today") }}
            </button>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, ref } from "vue";
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";
import { CalendarDaysIcon } from "@heroicons/vue/24/outline";
import { useTranslations } from "@/composables/useTranslations";

const { t } = useTranslations();

const props = defineProps<{
    date: string;
}>();

const localDate = ref(props.date);

const isToday = computed((): boolean => {
    const today = new Date().toISOString().slice(0, 10);
    return props.date === today;
});

const applyDate = (): void => {
    router.get(
        route("kiosk.daily-activity.index"),
        { date: localDate.value },
        { preserveState: false },
    );
};

const goToToday = (): void => {
    localDate.value = new Date().toISOString().slice(0, 10);
    router.get(
        route("kiosk.daily-activity.index"),
        {},
        { preserveState: false },
    );
};
</script>
